import React from 'react';

import {
  HeadingText,
  BodyText,
  Row,
  Col,
  Container,
} from '@paypalcorp/pp-react';
import styles from './benefits.less';
import glamorous from 'glamorous';

const BenefitColumn = glamorous.div({
  minHeight: '80px',
  marginTop: '15px',
  marginBottom: '25px',
  '@media(max-width: 500px)': {
    display: 'flex',
  },
});

const BenefitIcon = glamorous.img({
  width: '94px',
  '@media(max-width: 500px)': {
    width: '100px',
    height: '82px',
    paddingRight: '22px',
  },
});

const ListTextStyle = {
  paddingLeft: '0px',
};

const Benefits = ({ i18n, cdnHost }) => {
  return (
    <Container>
      <Row>
        <Col>
          <HeadingText as='h1' size='md' className={styles['npo-charityTitle']}>
            {i18n('label.all-to-charity')}
          </HeadingText>
        </Col>
      </Row>
      <Row>
        <Col lg={'4'}>
          <BenefitColumn>
            <BenefitIcon
              alt=''
              src={`https://${cdnHost}/paypal-ui/illustrations/focused/svg/clipboard-heart.svg`}
            />
            <div style={ListTextStyle}>
              <BodyText strong size='md' className={styles['benefits-text']}>
                {i18n('label.trusted-nonprofit')}
              </BodyText>
              <BodyText as='p' size='md' className={styles['benefits-text']}>
                {i18n('label.vet-confirm-status')}
              </BodyText>
            </div>
          </BenefitColumn>
        </Col>
        <Col lg={'4'}>
          <BenefitColumn>
            <BenefitIcon
              alt=''
              src={`https://${cdnHost}/paypal-ui/illustrations/focused/svg/hand-coin-bills.svg`}
            />
            <div style={ListTextStyle}>
              <BodyText strong size='md' className={styles['benefits-text']}>
                {i18n('label.we-pay-fee')}
              </BodyText>
              <BodyText as='p' size='md' className={styles['benefits-text']}>
                {i18n('label.pp-pays-100%')}
              </BodyText>
            </div>
          </BenefitColumn>
        </Col>
        <Col lg={'4'}>
          <BenefitColumn>
            <BenefitIcon
              alt=''
              src={`https://${cdnHost}/paypal-ui/illustrations/focused/svg/donation-receipt.svg`}
            />
            <div style={ListTextStyle}>
              <BodyText strong size='md' className={styles['benefits-text']}>
                {i18n('label.rcv-tax-rept')}
              </BodyText>
              <BodyText
                as='p'
                size='md'
                className={styles['benefits-text']}
                dangerouslySetInnerHTML={{
                  __html: i18n('label.send-tax-receipt'),
                }}
              />
            </div>
          </BenefitColumn>
        </Col>
      </Row>
    </Container>
  );
};

export default Benefits;
